// Interfaces baseadas no OpenAPI
export interface Topico {
  id: string;
  descricao: string;
  etiquetas: string[];
  arquivado: boolean;
  ativo: boolean;
  contexto?: string;
  metodoValidacao: 'Agente' | 'IA';
  status: 'Aguardando Aprovação' | 'Aprovado' | 'Reprovado';
  tipo: 'Problema' | 'Evento' | 'Sugestão';
}

export interface TopicoCompacto {
  id: string;
  descricao: string;
  arquivado: boolean;
  contexto?: string;
  metodoValidacao: 'Agente' | 'IA';
  ativo: boolean;
  etiquetas: string[];
  /** Município ao qual o tópico pertence. Quando `null` o tópico é considerado
   *  global (do sistema) e não pode ser editado pelo gestor da ouvidoria. */
  municipioId?: number | string | null;
}

// Classes utilitárias para conversão e manipulação
export class TopicoModel {
  static empty(): Topico {
    return {
      id: '',
      descricao: '',
      etiquetas: [],
      arquivado: false,
      ativo: false,
      contexto: undefined,
      metodoValidacao: 'Agente',
      status: 'Aguardando Aprovação',
      tipo: 'Problema',
    };
  }

  static fromMap(map: Record<string, unknown>): Topico {
    return {
      id: (map.id as string) || '',
      descricao: (map.descricao as string) || '',
      etiquetas: (map.etiquetas as string[]) || [],
      arquivado: (map.arquivado as boolean) || false,
      ativo: (map.ativo as boolean) || false,
      contexto: map.contexto as string,
      metodoValidacao: (map.metodoValidacao as 'Agente' | 'IA') || 'Agente',
      status: (map.status as 'Aguardando Aprovação' | 'Aprovado' | 'Reprovado') || 'Aguardando Aprovação',
      tipo: (map.tipo as 'Problema' | 'Evento' | 'Sugestão') || 'Problema',
    };
  }

  static listFromMap(list: unknown[]): Topico[] {
    return list.length === 0 ? [] : list.map(item => TopicoModel.fromMap(item as Record<string, unknown>));
  }
}

export class TopicoCompactoModel {
  static empty(): TopicoCompacto {
    return {
      id: '',
      descricao: '',
      arquivado: false,
      contexto: undefined,
      metodoValidacao: 'Agente',
      ativo: false,
      etiquetas: [],
    };
  }

  static fromMap(map: Record<string, unknown>): TopicoCompacto {
    return {
      id: (map.id as string) || '',
      descricao: (map.descricao as string) || '',
      arquivado: (map.arquivado as boolean) || false,
      contexto: map.contexto as string,
      metodoValidacao: (map.metodoValidacao as 'Agente' | 'IA') || 'Agente',
      ativo: (map.ativo as boolean) || false,
      etiquetas: (map.etiquetas as string[]) || [],
      municipioId: (map.municipioId as number | string | null | undefined) ?? null,
    };
  }

  static listFromMap(list: unknown[]): TopicoCompacto[] {
    return list.length === 0 ? [] : list.map(item => TopicoCompactoModel.fromMap(item as Record<string, unknown>));
  }
}
